import { eTipoPermissao } from '@/enums/ePermissoes';
import { cadastrosRota, TipoCadastroRota } from '@/models/transporte/trarota.model';

export default (Object.keys(cadastrosRota) as TipoCadastroRota[]).flatMap((tipo) => {
  const cadastro = cadastrosRota[tipo];
  const path = tipo === 'rota' ? '/transporte/trarota' : `/transporte/trarota/:traRotaId/${tipo}`;
  const meta = { permissions: [eTipoPermissao.ROTASNOVO_MENU_1100200399], tipoCadastroRota: tipo };
  return [
    {
      description: cadastro.titulo,
      path,
      name: cadastro.nome,
      parent: tipo === 'rota' ? undefined : 'trarota',
      component: () => import('@/views/transporte/trarota/Index.vue'),
      meta,
      goesToMenu: tipo === 'rota',
    },
    {
      description: `Cadastro de ${cadastro.singular}`,
      path: `${path}/cadastro/:id?`,
      name: `${cadastro.nome}-create`,
      parent: cadastro.nome,
      component: () => import('@/views/transporte/trarota/InclusaoEdicao.vue'),
      meta,
      goesToMenu: false,
    },
  ];
});
